import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-nav-15",
  "use": "icon-icon-nav-15-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-nav-15\"><path d=\"M493.632 401.6a92.032 92.032 0 1 0 0 184.064 92.032 92.032 0 0 0 0-184.064zM806.4 217.6H217.6c-40.448 0-73.6 33.152-73.6 73.6v441.6c0 40.512 33.152 73.6 73.6 73.6h588.8c40.512 0 73.6-33.152 73.6-73.6v-441.6c0-40.448-33.152-73.6-73.6-73.6z m-118.144 522.88L581.184 633.536a163.2 163.2 0 0 1-87.936 25.728 165.312 165.312 0 0 1-165.248-165.632 165.376 165.376 0 0 1 165.632-165.568A165.376 165.376 0 0 1 659.2 493.632c0 32.384-9.6 62.144-25.728 87.936l107.072 106.688-52.288 52.288z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/icon-nav-15.svg
// module id = V4C/
// module chunks = 3